"use client";

import { Suspense } from "react";
import { usehasRenderedOnce } from "../../utils/useIsBrowser";
import dynamic from "next/dynamic";

const CodeSection = dynamic(() => import("./CodeSection"), {
  ssr: false,
});

export function Pre({ children, className, ...props }) {
  const displayDynamic = usehasRenderedOnce();
  const fallback = (
    <pre
      {...props}
      className={className}
      style={{ paddingTop: "15px", paddingBottom: "36px" }}
    >
      {children}
    </pre>
  );

  if (!displayDynamic) {
    return fallback;
  }

  return (
    <Suspense fallback={fallback}>
      <CodeSection {...props} className={className}>
        {children}
      </CodeSection>
    </Suspense>
  );
}
